import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderCopy } from '@models/cms/header.model';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TopMenuTravelInfoMenuComponent } from './top-menu-travel-info-menu/top-menu-travel-info-menu.component';

@Component({
  selector: 'app-top-menu',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ModalModule,
    TopMenuTravelInfoMenuComponent,
  ],
  templateUrl: './top-menu.component.html',
  styleUrl: './top-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopMenuComponent {
  @Input() headerCopy: HeaderCopy;
  @Input() hasStations: boolean;
  @Input() isFlifoEnabled: boolean;
  @Output() bookNowClick = new EventEmitter<void>();

  onBookNowClick(): void {
    this.bookNowClick.emit();
  }
}
